// extracted by mini-css-extract-plugin
export default {"scrollableUserList":"UsersList-module__scrollableUserList--v1HiT"};